import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { styles } from "../MenuSeparator.styles";
/**
 * Добавляет разделительную линию между элементами меню.
 *
 * Сущности в которых может быть использован `MenuSeparator`: [`DropdownMenu`](#/Components/DropdownMenu), [`Kebab`](#/Components/Kebab), [`TooltipMenu`](#/Components/TooltipMenu) и [`Select`](#/Components/Select).
 */

function MenuSeparator(props) {
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(CommonWrapper, props, /*#__PURE__*/React.createElement("div", {
    className: styles.root(theme)
  }));
}

MenuSeparator.__KONTUR_REACT_UI__ = 'MenuSeparator';
export { MenuSeparator };